import { render } from "./StoreVsStore.vue?vue&type=template&id=475a106e&scoped=true"
import script from "./StoreVsStore.vue?vue&type=script&lang=js"
export * from "./StoreVsStore.vue?vue&type=script&lang=js"

import "./StoreVsStore.vue?vue&type=style&index=0&id=475a106e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475a106e"]])

export default __exports__